import { createFileRoute } from "@tanstack/react-router"

import { SettingsCompanyBrandingPage } from "@/pages/settings/company-branding"

// Open to any authenticated user so viewers see the company name read-only; the page disables
// the input without ACCOUNT_SETTINGS_UPDATE and the backend PATCH still enforces it.
export const Route = createFileRoute("/_authenticated/settings/company")({
  component: SettingsCompanyBrandingPage,
})
